import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-solution',
  templateUrl: './our-solution.component.html',
  styleUrls: ['./our-solution.component.scss']
})
export class OurSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
